import { fetchSources } from '@/core/api/sources'
import {
  CLEAR_STATE,
  END_REQUEST,
  SET_FILTER,
  SET_ORDERING,
  SET_PAGE,
  SET_PAGINATION,
  SET_STATE,
  START_REQUEST,
} from './mutation-types'

export default {
  namespaced: true,
  state: {
    loading: false,
    items: [],
    itemsCount: 0,
    pages: 1,
    page: 1,
    filter: {
      query: '',
      empty: false,
      activeParsing: true,
    },
    ordering: null,
  },
  actions: {
    async FETCH({ commit, state }) {
      commit(START_REQUEST)

      const data = await fetchSources({
        page: state.page,
        ordering: state.ordering,
        ...state.filter,
      })
      commit(SET_STATE, data)
      commit(SET_PAGINATION, data)
      commit(END_REQUEST)
    },
  },
  mutations: {
    [START_REQUEST]: state => {
      state.loading = true
    },
    [END_REQUEST]: state => {
      state.loading = false
    },
    [CLEAR_STATE]: state => {
      state.items = []
      state.itemsCount = 0
    },
    [SET_STATE]: (state, { results, count }) => {
      state.items = results
      state.itemsCount = count
    },
    [SET_PAGINATION]: (state, { pages }) => {
      state.pages = pages
    },
    [SET_FILTER]: (state, filter) => {
      state.filter = filter
    },
    [SET_PAGE]: (state, page) => {
      state.page = page
    },
    [SET_ORDERING]: (state, ordering) => {
      state.ordering = ordering
    },
  },
}
